import React from 'react';
import cn from 'classnames';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTranslation } from 'react-i18next';

import styles from './Stepper.module.scss';

interface StepperComponentProps {
  items: Array<{ title: string; disabled: boolean }>;
  activeIndex: number;
  setActiveIndex: (val: number) => void;
}

export const StepperComponent: React.FC<StepperComponentProps> = ({ items, activeIndex, setActiveIndex }) => {
  const { t } = useTranslation();
  const overlayWidth = ((activeIndex + 1) / items.length) * 100;
  return (
    <div className={styles.stepper_wrapper}>
      <div className={cn(styles.steppers)}>
        {items?.map((item, id) => {
          const isActiveStep = activeIndex >= id && !item.disabled;
          return (
            <button
              key={id}
              className={cn(styles.stepperItem, isActiveStep && styles.active)}
              onClick={() => setActiveIndex(id)}
              disabled={item.disabled}
            >
              <span>
                {t('stepper:step')} {id + 1}
              </span>
              {item.title}
              <div className={cn(styles.icon_wrapper, isActiveStep && styles.active)}>
                <VerifiedIcon fontSize="large" style={{ color: '#479955' }} />
              </div>
            </button>
          );
        })}
      </div>
      <div className={cn(styles.stepper_progress)}>
        <span className={styles.overlay} style={{ width: `${overlayWidth}%` }}></span>
      </div>
    </div>
  );
};
